import type { FC, ReactNode } from 'react';
import { AppShellManager } from 'src/components/layout/app-shell/app-shell-manager';
import { ContextualSidebar } from 'src/components/layout/app-shell/contextual-sidebar';
import {
  Sidebar,
  SidebarSkeleton,
} from 'src/components/layout/app-shell/sidebar';
import { useAppShellData } from 'src/components/layout/app-shell/use-app-shell-data';
import { useAppShell } from 'src/components/layout/app-shell/use-app-shell-provider';

type AppShellProps = {
  children: ReactNode;
};

export const AppShell: FC<AppShellProps> = ({ children }) => {
  const appShellData = useAppShellData();
  const { contextualSidebarPortal } = useAppShell();
  return (
    <AppShellManager
      contextualSidebarTargetRef={contextualSidebarPortal.targetRef}
      sidebar={(props) =>
        appShellData ? (
          <Sidebar appShellData={appShellData} {...props} />
        ) : (
          <SidebarSkeleton {...props} />
        )
      }
      contextualSidebar={
        <ContextualSidebar>{contextualSidebarPortal.target}</ContextualSidebar>
      }
    >
      {children}
    </AppShellManager>
  );
};
